// The B Marketplace badge: a little bee in a honeycomb hexagon, in ShopaBee yellow and navy.
export const BeeBadge = ({ size = 28, className = "", testId = "bee-badge" }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" className={`shrink-0 ${className}`} role="img" aria-label="The B Marketplace" data-testid={testId}>
    <path d="M20 2 35.6 11v18L20 38 4.4 29V11Z" fill="#FFD23F" stroke="#202A35" strokeWidth="2.5" strokeLinejoin="round" />
    <ellipse cx="14.5" cy="15" rx="5" ry="3.6" fill="#fff" stroke="#202A35" strokeWidth="1.8" transform="rotate(-25 14.5 15)" />
    <ellipse cx="25.5" cy="15" rx="5" ry="3.6" fill="#fff" stroke="#202A35" strokeWidth="1.8" transform="rotate(25 25.5 15)" />
    <ellipse cx="20" cy="23.5" rx="6.5" ry="7.5" fill="#FFD23F" stroke="#202A35" strokeWidth="2" />
    <path d="M14 21.5h12M13.6 25.5h12.8" stroke="#202A35" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="20" cy="15.5" r="3.4" fill="#202A35" />
  </svg>
);
